module.exports = __webpack_public_path__ + "static/meatball-sundae-0ccb82253c2f78276db341483325c79e.jpg";